var Signal,
  slice = [].slice;

Signal = require('../signal');

module.exports = function() {
  var signals;
  signals = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  return new Signal(function(send) {
    var subscriptions;
    subscriptions = signals.map(function(signal) {
      return signal.subscribe(send);
    });
    return function() {
      return subscriptions.forEach(function(unsubscribe) {
        return unsubscribe();
      });
    };
  });
};
